var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FE6170",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M36 19.5C36 10.387 28.613 3 19.5 3S3 10.387 3 19.5 10.057 36 19.17 36"
  })));
};
var Memo = /*#__PURE__*/memo(SvgLoader);
export default Memo;